import type { Printable } from './Printable';

export class Amperes implements ElectricCurrentType {
  readonly unit: 'A' = 'A' as const;
  private value: number | null;
  private constructor(electricCurrent: number | null) {
    this.value = electricCurrent;
  }

  static fromAmperes(amperes: number | null) {
    return new Amperes(amperes);
  }

  toString(options?: { withUnit?: boolean; numberOfDigits?: number }) {
    if (options?.numberOfDigits) {
      return `${
        this.value ? this.value.toFixed(options?.numberOfDigits) : '-'
      } ${this.unit}`;
    }
    return `${this.value ? this.value.toFixed(0) : '-'} ${this.unit}`;
  }

  toAmperes() {
    return this.value;
  }
}

export class KiloAmperes implements ElectricCurrentType {
  readonly unit: 'kA' = 'kA' as const;
  private value: number | null;
  private constructor(electricCurrent: number | null) {
    this.value = electricCurrent;
  }

  static fromCurrent(electricCurrent: ElectricCurrentType) {
    const apmersValue = electricCurrent.toAmperes();
    return this.fromAmperes(apmersValue);
  }

  static fromAmperes(amperes: number | null) {
    return amperes == null
      ? new KiloAmperes(null)
      : new KiloAmperes(amperes / 1000.0);
  }

  toString() {
    return `${this.value ? this.value.toFixed(0) : '-'} ${this.unit}`;
  }

  toAmperes() {
    return this.value == null ? null : this.value * 1000.0;
  }
}

export type ElectricCurrentType = Printable & {
  unit: 'A' | 'kA';
  toAmperes: () => number | null;
};
